let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hvmLe")).then(() => parcelRequire('dMZPm'));